<!-- Start -->
<section class="relative">
  <div class="container-fluid">
    <div class="grid md:grid-cols-12 gap-[30px]">
      <div class="lg:col-span-12 md:col-span-12">
        <div class="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
          <div class="grid lg:grid-cols-2 grid-cols-1 gap-5">
            <div>
              <h5 class="text-lg font-semibold mb-5">{{ "SETTINGS.GENERAL.EMAIL" | translate }}:</h5>

              <app-alert *ngIf="emailChangeError" type="danger">
                {{ emailChangeError }}
              </app-alert>

              <form [formGroup]="emailChangeForm" (ngSubmit)="submitChangeEmail()">
                <div class="grid grid-cols-1 gap-5">
                  <div>
                    <label class="form-label font-medium">{{ "SETTINGS.GENERAL.NEW_EMAIL" | translate }}:</label>
                    <input name="email" id="email" formControlName="email" type="email" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-2" [placeholder]="'SETTINGS.GENERAL.EMAIL_PLACEHOLDER' | translate">
                    <div *ngIf="emailChangeForm.get('email')?.invalid && emailChangeForm.get('email')?.touched" class="text-red-500 text-sm mt-1">
                      {{ 'SETTINGS.ERROR.INVALID_EMAIL' | translate }}
                    </div>
                  </div>
                </div><!--end grid-->

                <button class="btn bg-violet-600 hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white rounded-full mt-5" [disabled]="emailChangeForm.invalid || emailChangeLoading || !user?.emailVerified">
                  {{ "SETTINGS.GENERAL.CHANGE" | translate }}
                </button>
              </form>
            </div><!--end col-->

            <div>
              <h5 class="text-lg font-semibold mb-5">{{ "SETTINGS.GENERAL.CHANGE_PASSWORD" | translate }}:</h5>
              <app-alert *ngIf="changePasswordError" type="danger">
                {{ changePasswordError }}
              </app-alert>
              <form [formGroup]="changePasswordForm" (ngSubmit)="submitChangePassword()">
                <div class="grid grid-cols-1 gap-5">
                  <div>
                    <label class="form-label font-medium">{{ "SETTINGS.GENERAL.OLD_PASSWORD" | translate }}:</label>
                    <input type="password" formControlName="currentPassword" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-2" placeholder="Old password" required="">
                    <div *ngIf="changePasswordForm.get('currentPassword')?.invalid && changePasswordForm.get('currentPassword')?.touched" class="text-red-500 text-sm mt-1">
                      {{ 'SETTINGS.ERROR.REQUIRED_FIELD' | translate }}
                    </div>
                  </div>

                  <div>
                    <label class="form-label font-medium">{{ "SETTINGS.GENERAL.NEW_PASSWORD" | translate }}:</label>
                    <input type="password" formControlName="newPassword" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-2" placeholder="New password" required="">
                    <div *ngIf="changePasswordForm.get('newPassword')?.invalid && changePasswordForm.get('newPassword')?.touched" class="text-red-500 text-sm mt-1">
                      {{ 'SETTINGS.ERROR.REQUIRED_FIELD' | translate }}
                    </div>
                  </div>

                  <div>
                    <label class="form-label font-medium">{{ "SETTINGS.GENERAL.NEW_PASSWORD_RETYPE" | translate }}:</label>
                    <input type="password" formControlName="confirmPassword" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-2" placeholder="Re-type New password" required="">
                    <div *ngIf="changePasswordForm.get('confirmPassword')?.invalid && changePasswordForm.get('confirmPassword')?.touched" class="text-red-500 text-sm mt-1">
                      {{ 'SETTINGS.ERROR.REQUIRED_FIELD' | translate }}
                    </div>
                  </div>
                </div><!--end grid-->

                <button class="btn bg-violet-600 hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white rounded-full mt-5" [disabled]="changePasswordForm.invalid || changePasswordLoading">{{ "SETTINGS.GENERAL.SAVE_PASSWORD" | translate }}</button>
              </form>
            </div><!--end col-->
          </div><!--end row-->
        </div>
      </div>
    </div><!--end grid-->
  </div><!--end container-->
</section><!--end section-->
<!-- End Hero -->
